import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getDocumentNumbering,
  getParticularPage,
  getNext,
  getPrevious,
  createDocumentNumbering,
  updateDocumentNumbering,
  handleSearch,
  getDocumentNumberingById,
} from "./thunk";

const initialState = {
  documentNumberings: [],
  edit: false,
  documentNumbering: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingDocumentNumbering: false,
  loadingNext: false,
  showCreateModal: false,
};

export const documentNumberingSlice = createSlice({
  name: "documentNumbering",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllDocumentNumbering: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingDocumentNumbering = false;
      state.documentNumbering = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createDocumentNumbering.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createDocumentNumbering.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createDocumentNumbering.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getDocumentNumberingById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDocumentNumberingById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.documentNumbering = action.payload.data;
    });
    builder.addCase(getDocumentNumberingById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.documentNumbering = null;
    });
    builder.addCase(updateDocumentNumbering.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateDocumentNumbering.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateDocumentNumbering.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getDocumentNumbering.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingDocumentNumbering = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDocumentNumbering.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingDocumentNumbering = false;
        state.documentNumberings = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDocumentNumbering.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingDocumentNumbering = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllDocumentNumbering } = documentNumberingSlice.actions;

export default documentNumberingSlice.reducer;
